import {
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Textarea,
  toast,
} from "alm-react-components";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  ActionType,
  constants,
  LocationPathname,
  TabConstants,
  Tag,
} from "../../../../assets/constants/constants";
import { AppContext } from "../../../../context/AppProvider";
import getLocalizedContent from "../../../../lib/getLocalizedMetaData";
import { apis } from "../../../../services/alm";
import {
  almCommentId,
  almNotesReply,
  // almPostId,
  updateSequenceForNotes,
} from "../../../../services/notes";
// import { DiscussionBoard } from "../../../common/discussion-board/DiscussionBoard";
import RepliesList from "../../../common/tab-section/RepliesList";
import { Transcript } from "../../../common/Transcript";
import { getNexturlData } from "../../../../lib/utils";
import PageLoader from "../../../common/loader/PageLoader";
import useGaEventTracking from '../../../../hooks/UseGaEventTracking';
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../../../assets/constants/staticContentConstants';
import { putAppCuesData } from "../../../../lib/appcues";

interface TabSectionProps {
  courseResponse: any;
  mainLearningProgramId: string;
  learningProgramId: string;
  courseId: string;
  type: string;
  selectedProgram: string;
  transcriptLocation?: string;
  isUserEnrolled?: boolean;
  weekName?:string;
  currentLessionDetail:any;
}

export const DetailTabSection: React.FC<TabSectionProps> = ({
  courseResponse,
  mainLearningProgramId,
  learningProgramId,
  courseId,
  selectedProgram,
  transcriptLocation,
  isUserEnrolled,
  weekName,
  currentLessionDetail
}) => {
  const showTranscripts = courseResponse?.attributes?.tags?.includes(
    Tag.videos
  );
  const { t } = useTranslation();
  const { state, dispatch } = useContext(AppContext);
  const [tabIndex, setTabIndex] = useState(TabConstants.defaultTab);
  const [addNotesData, setnotesData] = useState("");
  // const [isAlmPostId, setIsAlmPostId] = useState("");
  const [isAlmCommentId, setIsAlmCommentId] = useState({
    commentId: "",
    notesCreated: 0,
  });
  const [query] = useSearchParams();
  const sequenceId: any = query.get("sequence");
  const [isAlmReplies, setIsAlmReplies] = useState([]);
  const [isLoadingOverview, setIsLoadingOverview] = useState(false);
  const [isLoadingTranscripts, setIsLoadingTranscripts] = useState(false);
  const gaEventTracker = useGaEventTracking();   

  const setTabAction = (action: string) => {
    if (tabIndex !== action) {
      // Start loading when switching to "Overview" tab
      if (action === TabConstants.defaultTab) {
        setIsLoadingOverview(true);
      }
      if (action === TabConstants.transcripts) {
        setIsLoadingTranscripts(true);
      }
      setTabIndex(action);
    }
  };

  useEffect(() => {
    setTabIndex(TabConstants.defaultTab);
  }, [courseId]);

    useEffect(() => {
      // Load content for the tab (Overview or Transcripts)
      if (tabIndex === TabConstants.defaultTab) {
        setIsLoadingOverview(false); 
      } else if (tabIndex === TabConstants.transcripts) {
        setIsLoadingTranscripts(false); 
      }
    }, [tabIndex]);

  const isCourseDetail =
    window.location.pathname.split("/")[1] === LocationPathname.courseDetail;

  const isHandleAddNotes = (e: any) => {
    setnotesData(e.target.value);
  };

  const getalmCommentId = async () => {
    const payload = {
      programId: isCourseDetail ? mainLearningProgramId : "", // send in case of program week only
      programName: isCourseDetail ? selectedProgram : "", // send in case of program week only
      weekId: isCourseDetail ? learningProgramId : "", // send in case of program week only
      weekName: isCourseDetail ? weekName : "", // send in case of program week only
      courseId: courseId, // Mandatory
      courseName: getLocalizedContent(
        courseResponse?.attributes?.localizedMetadata
      )?.name, // Mandatory
      sequenceId: isCourseDetail ? sequenceId : '00' // send 0 in case of library
    };
    try {
      dispatch({type: ActionType.CONTENT_LOADING, payload: true});
      const response: any = await almCommentId(payload);

      setIsAlmCommentId({
        commentId: response?.data?.getNotesComment?.almCommentId,
        notesCreated: response?.data?.getNotesComment?.notesCreated,
      });
      if (response?.data?.getNotesComment?.almCommentId) {
          const res:any = await apis.getRepliesBasedOnCommentId(response?.data?.getNotesComment?.almCommentId)
          let nextresult:any=[]
          if(res?.links?.next){
            nextresult= await getNexturlData(res)
          }else{
            nextresult=res?.data
        }
          const isDeletedData:any=nextresult?.filter((res:any)=>res?.attributes?.state !==constants.DELETED)
        setIsAlmReplies(isDeletedData);
      }
        dispatch({type: ActionType.CONTENT_LOADING, payload: false});
    } catch (error) {
      console.log("error from notes", error);
      dispatch({ type: ActionType.CONTENT_LOADING, payload: false });
    }
  };

  const handleSaveNotes = async () => {
    
    

    dispatch({type: ActionType.CONTENT_LOADING, payload: true});
    const payload = {
      data: {
        type: "reply",
        attributes: {
          dateCreated: new Date(),
          dateUpdated: new Date(),
          downVote: 0,
          richText: addNotesData,
          state: "ACTIVE",
          text: addNotesData,
          upVote: 0,
        },
        relationships: {
          createdBy: {
            data: {
              id: state?.user?.userId,
              type: "user",
            },
          },
          parent: {
            data: {
              id: isAlmCommentId?.commentId,
              type: "comment",
            },
          },
        },
      },
    };
    try {
      const response: any = await apis.addAlmNotes(
        isAlmCommentId?.commentId,
        payload
      );
      if (response?.data) {
        await updateSequenceForNotes(isAlmCommentId?.commentId);
      }
      if (response?.data && isAlmCommentId?.notesCreated == 0) {
        const payloadForReply = {
          almCommentId: isAlmCommentId?.commentId,
        };
        try {
          await almNotesReply(payloadForReply);
        } catch (e) {
          console.log("error", e);
        }
      }
      await getalmCommentId();
      toast({
        description: t("Common.notesCreated"),
        color: "white",
        variant: "success",
      });
      setnotesData("");
      const items = {
        value: null,
        currency: null,
        transaction_id: null,
        items: [{}],
        user_id:state.user?.userId,
        course_name:getLocalizedContent(
        courseResponse?.attributes?.localizedMetadata
              )?.name,
        note_length:addNotesData.length,
        course_id:courseId.split(':')[1],
    };
      gaEventTracker(analytics_event.NoteCreated,analytics_category.buttonClickCNoteCreated,analytics_label.noteCreatedLable,items);
      putAppCuesData({
        event_Name:appcues_event.lessonNoteAdded,
        eventName:`${appcues_event.lessonNoteAdded}_${currentLessionDetail?.data?currentLessionDetail?.data?.id:currentLessionDetail?.id}_${getLocalizedContent(
          courseResponse?.attributes?.localizedMetadata
                )?.name}`,
        userId: state.user?.email || "",
        lesson_id: currentLessionDetail?.data?currentLessionDetail?.data?.id:currentLessionDetail?.id,
        lessonName:getLocalizedContent(
          courseResponse?.attributes?.localizedMetadata
                )?.name
        });
    } catch (error) {
      console.log("error", error);
    }
    dispatch({type: ActionType.CONTENT_LOADING, payload: false});
  };

  return (
    <>
      <section className="">
        <div className="">
          <div className="mr-auto w-full">
            <div className="mt-1 text-sm leading-6 md:mt-0">
              <Tabs
                defaultValue="overview"
                value={tabIndex}
                className="w-full bg-transparent break-words"
              >
                <TabsList className="w-full bg-transparent items-start justify-start rounded-none h-auto p-0 border border-x-0 gap-x-8 max-sm:gap-x-3 px-4 xl:px-32 md:px-8 lg:px-8">
                  {isLoadingOverview ? (
                    <PageLoader />
                  ) : (
                    <TabsTrigger
                      value="overview"
                      className={`px-0 pb-5 pt-5 text-sm md:text-lg h-auto rounded-none mx-0 ml-0 md:mx-[0px] md:ml-[0px] ${
                        tabIndex === TabConstants.defaultTab
                          ? "border-b-[4px] dark:border-primary dark:text-white active:dark:border-primary"
                          : ""
                      }`}
                      onClick={() => setTabAction(TabConstants.defaultTab)}
                    >
                      <span dangerouslySetInnerHTML={{ __html: (t("Common.overview")) }} />
                    </TabsTrigger>
                  )}
                  {/* <TabsTrigger
                    value="discussion"
                    className={`px-0 pb-5 pt-5 text-sm md:text-lg h-auto rounded-none mx-0 md:mx-[0px] ${tabIndex === TabConstants.discussion
                        ? "border-b-[4px] dark:border-primary dark:text-white active:dark:border-primary"
                        : ""
                    }`}
                    onClick={() => setTabAction("discussion")}
                  >
                      <span dangerouslySetInnerHTML={{ __html: (t("Common.discussion")) }} />
                  </TabsTrigger> */}
                  {showTranscripts && (
                    <TabsTrigger
                      value="transcripts"
                      className={`px-0 pb-5 pt-5 text-sm md:text-lg h-auto rounded-none mx-0 md:mx-[0px] ${tabIndex === TabConstants.transcripts
                          ? "border-b-[4px] dark:border-primary dark:text-white active:dark:border-primary"
                          : ""
                      }`}
                      onClick={() => {
                        setTabAction("transcripts");
                      }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: (t("Common.transcripts")) }} />
                    </TabsTrigger>
                  )}
                  <TabsTrigger
                    value="mynotes"
                    className={`px-0 pb-5 pt-5 text-sm md:text-lg h-auto rounded-none mx-0 md:mx-[0px] ${tabIndex === TabConstants.myNotes
                        ? "border-b-[4px] dark:border-primary dark:text-white active:dark:border-primary"
                        : ""
                    }`}
                    onClick={() => {
                      setTabAction("mynotes");
                      getalmCommentId();
                    }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: (t("Common.myNotes")) }} />
                  </TabsTrigger>
                </TabsList>
                <TabsContent
                  value="overview"
                  className="w-full py-14 pb-8 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  {tabIndex === TabConstants.defaultTab && (
                    <div className="">
                      <h2 className="text-4xl font-barlowLight text-left pb-6"></h2>
                      {courseResponse &&
                      getLocalizedContent(
                        courseResponse?.attributes?.localizedMetadata
                      )?.richTextOverview ? (
                        <div
                          className="text-base font-normal font-sans pb-4 text-editor-class"
                          dangerouslySetInnerHTML={{
                            __html: getLocalizedContent(
                              courseResponse?.attributes?.localizedMetadata
                            )?.richTextOverview,
                          }}
                        ></div>
                      ) : (
                        <div className="flex w-full justify-center text-2xl mb-20">
                          <span dangerouslySetInnerHTML={{ __html: (t("Common.noOverviewContent")) }} />
                        </div>
                      )}
                    </div>
                  )}
                </TabsContent>
                {/* <TabsContent
                  value="discussion"
                  className="w-full py-14 pb-8 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  <div className="">

                    {tabIndex === TabConstants.discussion && courseId && (
                      <DiscussionBoard
                        mainLearningProgramId={mainLearningProgramId}
                        learningProgramId={learningProgramId}
                        courseId={courseId}
                        programName={selectedProgram}
                        courseName={getLocalizedContent(
                          courseResponse?.attributes?.localizedMetadata
                        )?.name}
                        currentLessionDetail={currentLessionDetail}
                      />
                    )}
                  </div>
                </TabsContent> */}
                <TabsContent
                  value="transcripts"
                  className="w-full py-14 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  {tabIndex === TabConstants.transcripts && (
                    <Transcript
                      transcriptLocation={transcriptLocation}
                      isUserEnrolled={isUserEnrolled}
                      setIsLoadingTranscripts={setIsLoadingTranscripts}
                      isLoadingTranscripts={isLoadingTranscripts}
                    />
                  )}
                </TabsContent>
                <TabsContent
                  value="mynotes"
                  className="w-full py-14 pb-8 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  {tabIndex === TabConstants.myNotes && (
                    <div className="">
                      <h2 className="text-4xl font-barlowLight text-left pb-6">
                        <span dangerouslySetInnerHTML={{ __html: (t("Common.myNotes")) }} />
                      </h2>

                      <div className="max-w-screen-xl mt-3">
                        <h4 className="font-light tracking-wider text-base font-barlowLight">
                          {t('Common.watchingNow')}
                        </h4>
                        <h2 className="text-xl font-sans font-normal text-left mt-1 mb-6">
                          {
                            getLocalizedContent(
                              courseResponse?.attributes?.localizedMetadata
                            )?.name
                          }
                        </h2>
                        <div className="mt-3 text-base font-opensansLight tracking-wider">
                          <Textarea
                            placeholder={t("PlaceHolder.typeYourAnsHere")}
                            rows={1}
                            onChange={(e) => isHandleAddNotes(e)}
                            className=""
                            value={addNotesData}
                          />
                          <div className="flex justify-end">
                            <Button
                              variant={"default"}
                              disabled={addNotesData ? false : true}
                              className="inline-flex rounded-sm text-base font-opensansSemiBold my-4 ml-4 py h-10 px-7 min-w-48"
                              onClick={() => handleSaveNotes()}
                            >
                              <span dangerouslySetInnerHTML={{ __html: (t("Common.save")) }} />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <RepliesList notesReplies={isAlmReplies} setIsAlmReplies={setIsAlmReplies} isAlmCommentId={isAlmCommentId?.commentId} />
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
